import { Popover as MantinePopover } from '@mantine/core';

export const Popover = MantinePopover.extend({
	defaultProps: {
		transitionProps: {
			duration: 0,
		},
	},
});
